import { IndianRupee, Trash2 } from 'lucide-react';
import * as React from 'react';
import { Card, CardContent } from '../ui/card';
import { CustomAlertDialog } from '../AlertDialog';

import { useSelector } from 'react-redux';
import { RootState } from '@/types';
import { useDelExpenseCategoryMutation } from '@/store/ExpenseCategoryApi';
import { toast } from 'sonner';
import { Link } from 'react-router-dom';

interface Ledger {
  ledger: string;
  _id: string;
}

interface Expense {
  ledger: Ledger;
  remark?: string;
  amount: number;
  date: string;
  month: string;
  year: string;
  createdAt: string;
  updatedAt: string;
  _id: string;
  __v: number;
}

export default function ExpanseCategories({
  allLedger,
  allExpanses,
}: {
  allLedger: Ledger[];
  allExpanses: Expense[];
}) {
  const { user } = useSelector((state: RootState) => state.user);
  const [deleteCategory] = useDelExpenseCategoryMutation();

  const expenseCategories = allLedger?.map((ledger: Ledger) => {
    return {
      _id: ledger._id,
      name: ledger.ledger,
      amount: allExpanses?.reduce((acc: number, expanse: Expense) => {
        if (expanse.ledger?._id === ledger?._id) {
          acc += expanse.amount;
        }
        return acc;
      }, 0),
      trend: '+12%',
      icon: IndianRupee,
    };
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {expenseCategories?.map((category, index) => (
        <Card
          key={index}
          className="hover:shadow-lg transition-shadow cursor-pointer"
        >
          <Link to={`${category.name}`}>
            <CardContent className="p-6">
              <div className="flex items-start justify-between">
                <div>
                  <p className="text-gray-600 mb-1">{category.name}</p>
                  <h3 className="text-2xl font-bold">₹{category.amount}</h3>
                  <div className={`flex items-center mt-2 `}>
                    <CustomAlertDialog
                      title="Delete Category"
                      description={
                        <>
                          Are you sure you want to delete the category
                          <span className="font-semibold text-primary">
                            {' '}
                            "{category.name}"{' '}
                          </span>
                          with an allocated amount of
                          <span className="font-semibold text-primary">
                            {' '}
                            ₹{category.amount}{' '}
                          </span>
                          ? <br /> <br /> *The amount will not be deleted from
                          the total expenses.
                        </>
                      }
                      onConfirm={() => {
                        deleteCategory({
                          Id: category._id,
                          Token: user?.token,
                        });
                      }}
                      triggerButton={
                        <button className="p-1 rounded-full hover:bg-red-50 text-red-600 transition-all duration-300 transform hover:scale-110">
                          {/* <Trash2 className="w-4 h-4 mr-1" /> */}
                        </button>
                      }
                    />
                  </div>
                </div>
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <category.icon className="w-6 h-6 text-green-600" />
                </div>
              </div>
            </CardContent>
          </Link>
        </Card>
      ))}
    </div>
  );
}
